module.exports = __webpack_public_path__ + "assets/img/ser_119022.bea25de6.png";